import { useState, useEffect, useCallback } from 'react';

const EMPTY = { bundleCode: '', pieces: [] };
const keyFor = () => `sfg_floor_clearance_draft_${localStorage.getItem('active_site_id') || 'default'}`;

const load = () => {
  try {
    const d = JSON.parse(localStorage.getItem(keyFor()) || 'null');
    return d && Array.isArray(d.pieces) ? d : EMPTY;
  } catch {
    return EMPTY;
  }
};

// Keeps the in-progress bundle across page refreshes on the scanner.
export const useFloorClearanceDraft = () => {
  const [draft, setDraft] = useState(load);

  useEffect(() => {
    if (draft.bundleCode || draft.pieces.length) localStorage.setItem(keyFor(), JSON.stringify(draft));
    else localStorage.removeItem(keyFor());
  }, [draft]);

  const setBundleCode = useCallback((bundleCode) => setDraft((d) => ({ ...d, bundleCode })), []);
  const addPiece = useCallback((piece) => setDraft((d) => ({ ...d, pieces: [piece, ...d.pieces] })), []);
  const removePiece = useCallback(
    (usn) => setDraft((d) => ({ ...d, pieces: d.pieces.filter((p) => p.usn_code !== usn) })), []);
  const reset = useCallback(() => setDraft(EMPTY), []);

  const sku = draft.pieces.length ? draft.pieces[draft.pieces.length - 1] : null;
  return { draft, sku, setBundleCode, addPiece, removePiece, reset };
};
